<template>
  <section
    class="w-[280px] overflow-hidden rounded-12 bg-elev-context-menu-bg shadow-overlay"
    data-test="message-views-viewer"
  >
    <div class="p-1">
      <button
        type="button"
        data-test="message-views-viewer-back"
        class="box-border flex h-9 w-full cursor-pointer items-center gap-1 rounded-8 px-2 text-body-r-14-20 text-fg-base-fg3 hover:bg-surf-neut-soft-hov"
        @click="emit('back')"
      >
        <wui-icon
          name="chevronLeftLgM"
          class="shrink-0"
        />
        <span>{{ $t('common.back') }}</span>
      </button>
    </div>
    <hr class="mx-2 border-t border-bor-nav">

    <ul class="flex max-h-[320px] flex-col gap-[14px] overflow-y-auto px-4 py-[11px]">
      <li
        v-for="viewer in viewers"
        :key="viewer.contactId"
      >
        <message-view-list-item
          :author="viewer.contactId"
          :timestamp="viewer.timestamp"
        />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useStoreLastReadEventIds } from '@/entities/room'

import MessageViewListItem from './message-view-list-item.vue'

const props = defineProps<{
  eventId: number
  pServed: string
}>()

const emit = defineEmits<{
  (event: 'back'): void
}>()

const lastReadStore = useStoreLastReadEventIds()
const {
  lastMessageEventIdByRoomAndContactId,
  readTimestampsByMessageEventId,
} = storeToRefs(lastReadStore)
const { getViewersByMessageEventId } = lastReadStore

const viewers = computed(() => {
  void lastMessageEventIdByRoomAndContactId.value[props.pServed]
  void readTimestampsByMessageEventId.value
  return getViewersByMessageEventId(props.pServed, props.eventId)
})
</script>
